import React, { useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import tuhinLogo from '../assets/tuhinlogo.png'
import resumeFile from '../assets/resume/tuhinKairi.pdf'

const workLinks = [
  { label: 'Work', to: '/myworks' },
  { label: 'Case Studies', to: '/case-studies' },
  { label: 'Architecture', to: '/system-architecture-design' },
]

const baseLinkClass = 'transition-colors hover:text-secondary'
const activeLinkClass = 'text-secondary underline underline-offset-4 transition-colors'

export default function Navbar() {
  const location = useLocation()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [mobileWorkOpen, setMobileWorkOpen] = useState(false)

  const isContactActive = location.pathname === '/' && location.hash === '#connect'
  const isWorkGroupActive = workLinks.some((item) => location.pathname === item.to)

  return (
    <div className="fixed z-30 w-full bg-ground/95 backdrop-blur sm:px-6">
      <nav className="container relative mx-auto flex items-center justify-between px-4 py-4 sm:px-5 lg:px-0 lg:py-4">
        <div className="font-heading text-primary">
          <Link to="/" aria-label="home">
            <img loading="lazy" src={tuhinLogo} alt="logo" className="h-9 w-9 sm:h-10 sm:w-10" />
          </Link>
        </div>

        <div className="hidden items-center gap-5 text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-primary md:flex lg:gap-6">
          <NavLink className={({ isActive }) => (isActive ? activeLinkClass : baseLinkClass)} to="/">Home</NavLink>
          <NavLink className={({ isActive }) => (isActive ? activeLinkClass : baseLinkClass)} to="/about">About</NavLink>
          {workLinks.map((item) => (
            <NavLink key={item.to} className={({ isActive }) => (isActive ? activeLinkClass : baseLinkClass)} to={item.to}>
              {item.label}
            </NavLink>
          ))}
          <NavLink className={isContactActive ? activeLinkClass : baseLinkClass} to="/#connect">Contact</NavLink>
          <a
            href={resumeFile}
            download="Tuhin-Kairi-Resume.pdf"
            className="rounded-full border border-primary bg-primary px-4 py-2 text-[0.65rem] uppercase tracking-[0.2em] text-ground transition-colors hover:bg-transparent hover:text-primary"
          >
            Resume
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMobileMenuOpen((prev) => !prev)}
          className="inline-flex items-center rounded-full border border-border px-4 py-2 text-[0.65rem] font-semibold uppercase tracking-[0.22em] text-primary transition-colors hover:border-primary hover:text-primary md:hidden"
          aria-expanded={mobileMenuOpen}
          aria-controls="mobile-nav-panel"
        >
          Menu
        </button>

        {mobileMenuOpen ? (
          <div
            id="mobile-nav-panel"
            className="absolute left-4 right-4 top-full mt-3 rounded-[1.5rem] border border-border bg-surface p-4 text-[0.72rem] font-semibold uppercase tracking-[0.22em] text-primary shadow-[0_18px_50px_rgba(17,17,17,0.08)] md:hidden"
          >
            <div className="flex flex-col gap-4">
              <NavLink
                className={({ isActive }) => (isActive ? activeLinkClass : baseLinkClass)}
                to="/"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </NavLink>
              <NavLink
                className={({ isActive }) => (isActive ? activeLinkClass : baseLinkClass)}
                to="/about"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </NavLink>

              <div className="rounded-[1.25rem] border border-border bg-ground px-4 py-3">
                <button
                  type="button"
                  onClick={() => setMobileWorkOpen((prev) => !prev)}
                  className={`flex w-full items-center justify-between ${isWorkGroupActive ? activeLinkClass : baseLinkClass}`}
                >
                  <span>Portfolio Sections</span>
                  <span>{mobileWorkOpen ? '-' : '+'}</span>
                </button>

                {mobileWorkOpen ? (
                  <div className="mt-3 flex flex-col gap-3 border-t border-border pt-3 text-[0.68rem]">
                    {workLinks.map((item) => (
                      <NavLink
                        key={item.to}
                        className={({ isActive }) => (isActive ? activeLinkClass : baseLinkClass)}
                        to={item.to}
                        onClick={() => {
                          setMobileMenuOpen(false)
                          setMobileWorkOpen(false)
                        }}
                      >
                        {item.label}
                      </NavLink>
                    ))}
                  </div>
                ) : null}
              </div>

              <NavLink
                className={isContactActive ? activeLinkClass : baseLinkClass}
                to="/#connect"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </NavLink>

              <a
                href={resumeFile}
                download="Tuhin-Kairi-Resume.pdf"
                className="rounded-full border border-primary bg-primary px-4 py-3 text-center text-[0.68rem] uppercase tracking-[0.22em] text-ground transition-colors hover:bg-transparent hover:text-primary"
              >
                Download Resume
              </a>
            </div>
          </div>
        ) : null}
      </nav>
    </div>
  )
}
